module.exports = __webpack_public_path__ + "img/interviews-empty-state.4b1e5c0a.svg";